export const TYPES = [
  {
    content: 'Transactional',
    name: 'transactional'
  },
  {
    content: 'Non-Transactional',
    name: 'non_transactional'
  }
];

export const SOURCES = [
  {
    content: 'Spam Complaint',
    name: 'Spam Complaint'
  },
  {
    content: 'List Unsubscribe',
    name: 'List Unsubscribe'
  },
  {
    content: 'Bounce Rule',
    name: 'Bounce Rule'
  },
  {
    content: 'Unsubscribe Link',
    name: 'Unsubscribe Link'
  },
  {
    content: 'Manually Added',
    name: 'Manually Added'
  },
  {
    content: 'Compliance',
    name: 'Compliance'
  }
];

export const RELATIVE_DATE_OPTIONS = ['hour', 'day', '7days', '30days', '90days', 'custom'];
